export default {
  "nl": {
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AFI": "Afars en Issas",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Ålandeilanden",
      "ALB": "Albanië",
      "AND": "Andorra",
      "ANT": "Nederlandse Antillen",
      "ARE": "Verenigde Arabische Emiraten",
      "ARG": "Argentinië",
      "ARM": "Armenië",
      "ASM": "Amerikaans-Samoa",
      "ATA": "Antarctica",
      "ATB": "Brits Antarctisch Territorium",
      "ATF": "Franse zuidelijke gebieden",
      "ATG": "Antigua en Barbuda",
      "ATN": "Koningin Maudland",
      "AUS": "Australië",
      "AUT": "Oostenrijk",
      "AZE": "Azerbeidzjan",
      "BDI": "Burundi",
      "BEL": "België",
      "BEN": "Benin",
      "BES": "Bonaire, Sint-Eustatius en Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesh",
      "BGR": "Bulgarije",
      "BHR": "Bahrein",
      "BHS": "Bahamas",
      "BIH": "Bosnië en Herzegovina",
      "BLM": "Saint-Barthélemy",
      "BLR": "Wit-Rusland",
      "BLZ": "Belize",
      "BMU": "Bermuda",
      "BOL": "Bolivië",
      "BRA": "Brazilië",
      "BRB": "Barbados",
      "BRN": "Brunei Darussalam",
      "BTN": "Bhutan",
      "BUR": "Birma",
      "BVT": "Bouveteiland",
      "BWA": "Botswana",
      "BYS": "Wit-Rusland",
      "CAF": "Centraal-Afrika",
      "CAN": "Canada",
      "CCK": "Cocos- (Keeling-) eilanden",
      "CHE": "Zwitserland",
      "CHL": "Chili",
      "CHN": "China",
      "CIV": "Ivoorkust",
      "CMR": "Kameroen",
      "COD": "Congo",
      "COG": "Congo",
      "COK": "Cookeilanden",
      "COL": "Colombia",
      "COM": "Comoren",
      "CPV": "Kaapverdië",
      "CRI": "Costa Rica",
      "CSK": "Tsjecho-Slowakije",
      "CTE": "Canton en Enderbury Eilanden",
      "CUB": "Cuba",
      "CUW": "Curaçao",
      "CXR": "Christmaseiland",
      "CYM": "Caymaneilanden",
      "CYP": "Cyprus",
      "CZE": "Tsjechië",
      "DDR": "Oost-Duitsland",
      "DEU": "Duitsland",
      "DHY": "Dahomey",
      "DJI": "Djibouti",
      "DMA": "Dominica",
      "DNK": "Denemarken",
      "DOM": "Dominicaanse Republiek",
      "DZA": "Algerije",
      "ECU": "Ecuador",
      "EGY": "Egypte",
      "ERI": "Eritrea",
      "ESH": "Westelijke Sahara",
      "ESP": "Spanje",
      "EST": "Estland",
      "ETH": "Ethiopië",
      "FIN": "Finland",
      "FJI": "Fiji",
      "FLK": "Falklandeilanden (Malvinas)",
      "FRA": "Frankrijk",
      "FRO": "Faeröereilanden",
      "FSM": "Micronesië",
      "FXX": "Metropolitaans Frankrijk",
      "GAB": "Gabon",
      "GBR": "Verenigd Koninkrijk",
      "GEL": "Gilberteilanden",
      "GEO": "Georgië",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinea",
      "GLP": "Guadeloupe",
      "GMB": "Gambia",
      "GNB": "Guinee-Bissau",
      "GNQ": "Equatoriaal-Guinea",
      "GRC": "Griekenland",
      "GRD": "Grenada",
      "GRL": "Groenland",
      "GTM": "Guatemala",
      "GUF": "Frans-Guyana",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hongkong",
      "HMD": "Heard- en McDonaldeilanden",
      "HND": "Honduras",
      "HRV": "Kroatië",
      "HTI": "Haïti",
      "HUN": "Hongarije",
      "HVO": "Opper-Volta",
      "IDN": "Indonesië",
      "IMN": "Eiland Man",
      "IND": "India",
      "IOT": "Brits Indische oceaan",
      "IRL": "Ierland",
      "IRN": "Iran",
      "IRQ": "Irak",
      "ISL": "Ijsland",
      "ISR": "Israël",
      "ITA": "Italië",
      "JAM": "Jamaica",
      "JEY": "Jersey",
      "JOR": "Jordanië",
      "JPN": "Japan",
      "JTN": "Johnston-atol",
      "KAZ": "Kazachstan",
      "KEN": "Kenia",
      "KGZ": "Kirgistan",
      "KHM": "Cambodja",
      "KIR": "Kiribati",
      "KNA": "Sankt Kitts, Nevis en Anguilla",
      "KOR": "Zuid Korea",
      "KWT": "Koeweit",
      "LAO": "Laos",
      "LBN": "Libanon",
      "LBR": "Liberia",
      "LBY": "Libië",
      "LCA": "Sint Lucia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Litouwen",
      "LUX": "Luxemburg",
      "LVA": "Letland",
      "MAC": "Macao",
      "MAF": "Sint Maarten (Frans deel)",
      "MAR": "Marokko",
      "MCO": "Monaco",
      "MDA": "Moldavië",
      "MDG": "Madagascar",
      "MDV": "Maldiven",
      "MEX": "Mexico",
      "MHL": "Marshalleilanden",
      "MID": "Midway-eilanden",
      "MKD": "Macedonië",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongolië",
      "MNP": "Noordelijke Marianen",
      "MOZ": "Mozambique",
      "MRT": "Mauritanië",
      "MSR": "Montserrat",
      "MTQ": "Martinique",
      "MUS": "Mauritius",
      "MWI": "Malawi",
      "MYS": "Maleisië",
      "MYT": "Mayotte",
      "NAM": "Namibië",
      "NCL": "Nieuw-Caledonië",
      "NER": "Niger",
      "NFK": "Norfolkeiland",
      "NGA": "Nigeria",
      "NHB": "Nieuwe Hebriden",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "Nederland",
      "NOR": "Noorwegen",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NTZ": "Neutrale Zone",
      "NZL": "Nieuw-Zeeland",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCI": "Trustgebied van de Pacifische Eilanden",
      "PCN": "Pitcairn",
      "PCZ": "Panamakanaalzone",
      "PER": "Peru",
      "PHI": "Filipijnen",
      "PHL": "Filipijnen",
      "PLW": "Palau",
      "PNG": "Papoea-Nieuw-Guinea",
      "POL": "Polen",
      "PRI": "Puerto Rico",
      "PRK": "Noord-Korea",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Bezette Palestijnse gebieden",
      "PUS": "Diverse pacifische eilanden van de V.S.",
      "PYF": "Frans-Polynesië",
      "QAT": "Qatar",
      "REU": "Réunion",
      "RHO": "Zuid-Rhodesië",
      "ROU": "Roemenië",
      "RUS": "Rusland",
      "RWA": "Rwanda",
      "SAU": "Saoedi-Arabië",
      "SCG": "Servië en Montenegro",
      "SDN": "Soedan",
      "SEN": "Senegal",
      "SGP": "Singapore",
      "SGS": "Zuid-Georgië en de Zuid-Sandwicheilanden",
      "SHN": "Sint Helena, Ascension en Tristan da Cunha",
      "SJM": "Svalbard en Jan Mayen",
      "SKM": "Sikkim",
      "SLB": "Salomonseilanden",
      "SLE": "Sierra Leone",
      "SLV": "El Salvador",
      "SMR": "San Marino",
      "SOM": "Somalië",
      "SPM": "Saint-Pierre en Miquelon",
      "SRB": "Servië",
      "SSD": "Zuid-Soedan",
      "STP": "São Tomé en Príncipe",
      "SUN": "Sovjet-Unie",
      "SUR": "Suriname",
      "SVK": "Slowakije",
      "SVN": "Slovenië",
      "SWE": "Zweden",
      "SWZ": "Swaziland",
      "SXM": "Sint Maarten (Nederlands deel)",
      "SYC": "Seychellen",
      "SYR": "Syrië",
      "TCA": "Turks- en Caicoseilanden",
      "TCD": "Tsjaad",
      "TGO": "Togo",
      "THA": "Thailand",
      "TJK": "Tadzjikistan",
      "TKL": "Tokelau",
      "TKM": "Turkmenistan",
      "TLS": "Oost-Timor",
      "TMP": "Portugees Timor",
      "TON": "Tonga",
      "TTO": "Trinidad en Tobago",
      "TUN": "Tunesië",
      "TUR": "Turkije",
      "TUV": "Tuvalu",
      "TWN": "Taiwan, Chinese provincie",
      "TZA": "Tanzanië",
      "UGA": "Oeganda",
      "UKR": "Oekraïne",
      "UMI": "Kleine afgelegen eilanden van de Verenigde Staten",
      "URY": "Uruguay",
      "USA": "Verenigde Staten",
      "UZB": "Oezbekistan",
      "VAT": "Heilige stoel",
      "VCT": "Saint Vincent en de Grenadines",
      "VDR": "Noord-Vietnam",
      "VEN": "Venezuela",
      "VGB": "Britse Maagdeneilanden",
      "VIR": "Amerikaanse Maagdeneilanden",
      "VNM": "Zuid-Vietnam",
      "VUT": "Vanuatu",
      "WAK": "Wake-eiland",
      "WLF": "Wallis en Futuna",
      "WSM": "Samoa",
      "XXX": "Onbekend",
      "YEM": "Noord-Jemen",
      "YMD": "Zuid-Jemen",
      "YUG": "Joegoslavië",
      "ZAF": "Zuid-Afrika",
      "ZAR": "Zaïre",
      "ZMB": "Zambia",
      "ZWE": "Zimbabwe"
    }
  }
}